import { isValidElement, cloneElement } from 'react';
import { isValidElementType } from 'react-is';
import invariant from 'react-utils/invariant';
import { jsx as _jsx } from "react/jsx-runtime";
const mergeTypes = {
  passive(originalProps, newProps) {
    return Object.assign({}, newProps, originalProps);
  },
  aggressive(originalProps, newProps) {
    return newProps;
  },
  none() {
    return {};
  }
};
const defaultOpts = {
  mergeType: 'passive'
};
export const render = (Renderer, props = {}, opts = {}) => {
  const {
    mergeType
  } = Object.assign({}, defaultOpts, opts);
  if (process.env.NODE_ENV !== 'production') {
    invariant(mergeType === 'passive' || mergeType === 'aggressive' || mergeType === 'none', `CustomRenderer: invalid merge type (expected aggressive|passive|none, got ${mergeType})`);
  }
  if ( /*#__PURE__*/isValidElement(Renderer)) {
    return /*#__PURE__*/cloneElement(Renderer, mergeTypes[mergeType](Renderer.props, props));
  }
  if (isValidElementType(Renderer)) {
    return /*#__PURE__*/_jsx(Renderer, Object.assign({}, props));
  }
  return Renderer;
};